import { Button } from '@/components/ui/button'
import { useAppVersionCheck } from '@/hooks/useAppVersionCheck'
import { XIcon } from 'lucide-react'

/**
 * Persistent, dismissible banner shown app-wide (regardless of route or
 * layout) once a newer deployment has been detected. Refreshing is always
 * left up to the user so in-progress form work is never discarded out from
 * under them.
 */
export function AppUpdateBanner() {
  const { updateAvailable, dismiss, refresh } = useAppVersionCheck()

  if (!updateAvailable) return null

  return (
    <div
      role="status"
      className="border-info bg-info-background text-info-foreground flex flex-wrap items-center justify-center gap-3 border-b px-4 py-2 text-sm"
    >
      <span>
        A new version of MCCS is available. Refresh when you&apos;re ready —
        your current session stays open until then.
      </span>
      <Button size="sm" onClick={refresh}>
        Refresh Now
      </Button>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss update notice"
        className="text-info-foreground/70 hover:text-info-foreground"
      >
        <XIcon className="size-4" aria-hidden="true" />
      </button>
    </div>
  )
}

export default AppUpdateBanner
